import videoSrc from 'assets/video/margin-onboarding.mp4'
import I18n from 'components/I18n'
import messages from 'lang'
import transparentize from 'polished/lib/color/transparentize'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

import { BackButton, Button, ButtonWrapper, ContentWrapper, Wrapper } from './common'

type Props = {
  onNext: () => void
  onPrev: () => void
}

const VideoWrapper = styled.div`
  background: linear-gradient(
    180deg,
    ${(p) => transparentize(0.8, color('primary')(p))} 70%,
    #ffffff 80%
  );
  padding: 1.5rem 2.5rem 0 2.5rem;

  video {
    width: 400px;
    border-radius: 0.5rem;
  }

  p {
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.25rem;
    text-align: center;
  }
`

const Video = ({ onNext, onPrev }: Props) => (
  <Wrapper>
    <VideoWrapper>
      <video controls>
        <source src={videoSrc} type='video/mp4' />
      </video>
      <p>Quick Margin Trading Walk Through</p>
    </VideoWrapper>
    <ContentWrapper>
      <ButtonWrapper>
        <BackButton onClick={onPrev}>
          <I18n data={messages.back} />
        </BackButton>
        <Button onClick={onNext}>
          <I18n data={messages.button_next} />
        </Button>
      </ButtonWrapper>
    </ContentWrapper>
  </Wrapper>
)

export default Video
